import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { WorkflowType } from 'modules/workflows/enums';
import { LeftTooltip } from 'ui/tooltip';
import { Truncate } from 'ui/utility/truncate';
import { colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledTruncate = styled(Truncate)`
  white-space: unset;
`;

const StyledWorkflowType = styled.div`
  color: ${colors.textSecondary};
  font-size: ${pxToRem(12)};
`;

type JournItemsProps = {
  name: string;
  workflowType: WorkflowType;
  id: number;
  enabled: boolean;
};

export const JourneyItem = ({ name, workflowType, id, enabled }: JournItemsProps) => {
  const status = enabled ? 'Live' : 'Off';
  const ref = useRef<HTMLButtonElement>(null);
  const maxWidth = 325;
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (ref?.current?.scrollWidth && ref?.current?.scrollWidth > maxWidth) {
      setIsTruncated(true);
    } else if (ref?.current?.scrollWidth && ref?.current?.scrollWidth <= maxWidth) {
      setIsTruncated(false);
    }
  });

  return (
    <>
      <LeftTooltip isEnabled={isTruncated} tooltipContent={name}>
        <StyledTruncate ref={ref} maxWidth={maxWidth}>
          {name}
        </StyledTruncate>
      </LeftTooltip>
      <StyledWorkflowType>{`ID ${id} | ${
        workflowType === WorkflowType.DRAFT ? workflowType : status
      }`}</StyledWorkflowType>
    </>
  );
};
